import {Divider, MenuItem, Typography} from '@mui/material';
import Box from '@mui/material/Box';
import {grey} from '@mui/material/colors';
import {oneOf} from 'prop-types';

import {BREAKPOINTS} from '../../../const';
import useBreakpoint from '../../../hooks/dom/useBreakpoint';
import useBanner from '../../../hooks/providers/useBanner';
import usePayment from '../../../hooks/providers/usePayment';
import {normaliseValue} from '../../../utils';
import CustomizedLinearProgress from '../../progress/LinearProgress';

// eslint-disable-next-line complexity
const HeaderTrialProgressBar = ({variant = BREAKPOINTS.xs}) => {
  const {numberOfTrialDaysLeft, totalNumberOfTrialDays} = usePayment();
  const currentBreakpoint = useBreakpoint();
  const {shouldDisplayTrialExpiredBanner, shouldDisplayTrialInProgressBanner} = useBanner();
  const isExtraSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  if (isExtraSmallScreen && variant !== BREAKPOINTS.xs) return null;
  if (!isExtraSmallScreen && variant === BREAKPOINTS.xs) return null;

  if (!shouldDisplayTrialInProgressBanner && !shouldDisplayTrialExpiredBanner) return null;

  const trialProgressionPercentage = normaliseValue(numberOfTrialDaysLeft, totalNumberOfTrialDays) ?? 0;
  const isSmallScreen = currentBreakpoint === BREAKPOINTS.sm;

  const renderSentence = () => {
    if (numberOfTrialDaysLeft === 0) {
      return <>Période d'essai terminée</>;
    }
    return (
      <>
        Jours d'essai : <b>{numberOfTrialDaysLeft}</b>
      </>
    );
  };

  if (variant === BREAKPOINTS.xs) {
    return (
      <>
        <Divider />
        <MenuItem
          disableRipple
          sx={{
            py: 0,
            cursor: 'help',
            '&:hover': {
              backgroundColor: 'white '
            }
          }}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Box display="flex" flexWrap="wrap">
            <Typography fontSize={14} sx={{color: 'text.primary !important', mb: 0.5}}>
              {renderSentence()}
            </Typography>
            <CustomizedLinearProgress emptyColor={grey[300]} variant="determinate" value={trialProgressionPercentage} />
          </Box>
        </MenuItem>
      </>
    );
  }

  const fontSize = isSmallScreen ? 9 : 12;
  const marginLeft = isSmallScreen ? 1 : 2;
  const maxWidth = isSmallScreen ? 70 : 'auto';

  return (
    <Box ml={marginLeft} maxWidth={maxWidth} display="flex" flexWrap="wrap" minWidth={65}>
      <Typography fontSize={fontSize} sx={{color: 'white !important', mb: 0.5}}>
        {renderSentence()}
      </Typography>
      <CustomizedLinearProgress emptyColor="white" variant="determinate" value={trialProgressionPercentage} />
    </Box>
  );
};

HeaderTrialProgressBar.propTypes = {
  variant: oneOf(Object.values(BREAKPOINTS)).isRequired
};

export default HeaderTrialProgressBar;
